import { DatabaseEntities } from "../../../common/models/database-entities.model";

export class SpreaderWidths extends DatabaseEntities<SpreaderWidths> {
    value: string;
}
